// components/layout/BurgerMenu.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../App.module.css';

const BurgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button className={styles.menuToggle} onClick={toggleMenu}>
        ☰
      </button>

      {isOpen && <div className={styles.backdrop} onClick={closeMenu} />}

      <div className={`${styles.menuDrawer} ${isOpen ? styles.open : ''}`}>
        <nav className={styles.menuNav}>
        <Link to="/" onClick={closeMenu}>Welcome</Link>
        <Link to="/chat" onClick={closeMenu}>Chat</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/privacy" onClick={closeMenu}>Privacy</Link>
        <Link to="/faq" onClick={closeMenu}>FAQ</Link>
        <Link to="/login" onClick={closeMenu}>Log In</Link>
        <Link to="/register" onClick={closeMenu}>Register</Link>
        <Link to="/help" onClick={closeMenu}>Help</Link>
        <Link to="/contact" onClick={closeMenu}>Contact</Link>
        <Link to="/terms" onClick={closeMenu}>Terms</Link>
        <Link to="/founder" onClick={closeMenu}>Founder</Link>
         </nav>
      </div>
    </>
  );
};

export default BurgerMenu;
